'use client';
import { NoticeWithIcon, Spacing } from '~/components';
import { Button } from '@bgzt/ui';
import { Dialog, Typography } from '@bgzt/ui';

import { Link } from '~/components/Link';
import { useEnvironmentInfo, useGoBack } from '~/hooks';
import { useRouter } from 'next/navigation';

export default function RootNotFound() {
  const { isWebview } = useEnvironmentInfo();
  const router = useRouter();
  const { goBack } = useGoBack();

  return (
    <>
      <Dialog
        title="삭제된 상품입니다."
        onClose={() => {
          isWebview ? goBack() : router.replace('/');
        }}
        isOpen
      />
      <Spacing height={120} />
      <NoticeWithIcon iconType="error">
        <Spacing height={12} />
        <Typography variant="S1" color="gray-900" as="p">
          존재하지 않는 상품입니다.
        </Typography>
        <Spacing height={20} />
        <Button variant="normalLine">
          <Link href={'/'}>홈으로 이동</Link>
        </Button>
      </NoticeWithIcon>
    </>
  );
}
